import { useCallback, useMemo, useRef } from "react";

/**
 * react-nestable cancels an in-progress drag as soon as *any* of its props
 * changes by reference (componentDidUpdate → stopTrackMouse + dragItem=null).
 * Inline `renderItem` / `onChange` arrows therefore kill the drag on every
 * parent re-render, which shows up as "sometimes I can drag, sometimes it's
 * blocked". This hook returns stable wrappers that always call the latest
 * implementation, plus a unique `group` so nested lists never share the
 * module-level random group react-nestable uses by default.
 */
const useStableNestable = ({ renderItem, onChange }) => {
  const renderRef = useRef(renderItem);
  const changeRef = useRef(onChange);
  renderRef.current = renderItem;
  changeRef.current = onChange;

  const stableRenderItem = useCallback((args) => renderRef.current(args), []);
  const stableOnChange = useCallback((args) => changeRef.current?.(args), []);
  const group = useMemo(() => `mt-${Math.random().toString(36).slice(2, 10)}`, []);

  return { renderItem: stableRenderItem, onChange: stableOnChange, group };
};

export default useStableNestable;
